import request from './request.js';
import {requestbody} from './request.js'
//日志查询
export async function page (params = {}) {
	return await requestbody('/system/log/page', 'get', params)
}